<template>
  <div class="invoice-register">
    <custom-dialog width="1280px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <el-form :model="form" ref="form" label-position="top" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="12" >
              <el-form-item
                :label="$t('fms_invoice_register_dialog.fa_piao_bian_hao')"
                prop="invoiceNum"
              >
                <el-input
                  v-model="form.invoiceNum"
                  maxlength="22"
                  style="width:100%;"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" >
              <el-form-item :label="$t('fms_invoice_register_dialog.kai_piao_ri_qi')" prop="invoiceTime" :rules="rules.invoiceTime">
                 <custom-date-picker
                  style="width: 100%;"
                  v-model="form.invoiceTime"
                  align="right"
                  type="date"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  :picker-options="beforeToday"
                ></custom-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12" >
              <el-form-item :label="$t('fms_invoice_register_dialog.bzzdtcbz')" prop="invoiceRemark">
                <el-input type="textarea" :rows="3" placeholder="" v-model="form.invoiceRemark" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" >
              <el-form-item :label="$t('fms_invoice_register_dialog.fa_piao_di_zhi')" prop="invoiceUrl">
                <el-input type="textarea" :rows="3" placeholder="" v-model="form.invoiceUrl" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="record-detail">
          <div class="item-title">{{ $t('fms_invoice_register_dialog.fa_piao_xin_xi') }}</div>
          <invoice-ticket :data="invoiceInfo" :type="invoiceInfo.isRedInvoice"></invoice-ticket>
          <div class="item-title">{{ $t('fms_invoice_register_dialog.fa_piao_ming_xi') }}</div>
          <!-- invoiceBillList -->
          <invoice-billList  :data="invoiceInfo.invoiceBillList" :type="invoiceInfo.isRedInvoice"></invoice-billList>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button  @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="onConfirm()">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import invoiceTicket from '@/pages/fms/components/invoice_ticket.vue';
import invoiceBillList from '@/pages/fms/components/invoice_billList.vue';

export default {
  mixins: [dialogMixins],
  components: { invoiceTicket, invoiceBillList },
  data() {
    return {
      tableList: [],
      form: {
        invoiceId: '',
        invoiceNum: '',
        invoiceRemark: '',
        invoiceTime: '',
        invoiceUrl: '',
      },
      invoiceId: '',
      // isRedInvoice true是冲红
      // isRedInvoice false是蓝票
      isRedInvoice: false,
      invoiceInfo: {}
    };
  },
  mounted() {
    // this.tableList = JSON.parse(JSON.stringify(this.model.row));
    this.invoiceId = this.model.row.invoiceId;
    this.isRedInvoice = this.model.row.isRedInvoice;
    // 自动填充备注
    this.form.invoiceRemark = this.model.row.invoiceRemark;
    this.getInvoiceDetail();
  },

  computed: {
    rules() {
      return {
        invoiceNum: [
          { required: true, message: this.$t('fms_invoice_register_dialog.qtxfpbh') },
          { type: 'string', min: 8, message: this.$t('fms_invoice_register_dialog.cdbxs8wsz'), trigger: 'blur' }
        ],
        invoiceTime: [
          { required: true, message: this.$t('fms_invoice_register_dialog.qxzkprq') },
        ],
      };
    },
  },
  methods: {
    // 确认保存
    onConfirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }

        if (!(/^[0-9]*$/).test(this.form.invoiceNum)) {
          this.$message.error(this.$t('fms_invoice_register_dialog.fpbhxwsz'));
          return;
        }

        // const tableList = this.$formatCopyUp(this.tableList, ['invoiceType', 'itemName', 'taxRate', 'itemUnit']);
        // const hasEmpty = tableList.find(t => !t.invoiceType || !t.itemName || !t.taxRate);
        // if (hasEmpty) {
        //   this.$message.error('请将数据填写完整');
        //   return;
        // }
        // this.form.billList = tableList.map(t => ({ billId: t.billId, isRedInvoice: false, invoiceType: t.invoiceType, itemName: t.itemName, taxRate: t.taxRate, itemUnit: t.itemUnit }));

        this.form.invoiceId = this.invoiceId;
        // isRedInvoice true是冲红
        // isRedInvoice false是蓝票
        if (this.isRedInvoice) {
          this.$postJSON(apis.invoiceGoRedRegister, this.form).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success'
            });
            this.visible = false;
            this.$emit('success', this.form);
          });
        } else {
          this.$postJSON(apis.invoiceRegister, this.form).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success'
            });
            this.visible = false;
            this.$emit('success', this.form);
          });
        }

      });
    },
    // 发票详情
    getInvoiceDetail: function () {
      // isRedInvoice true是冲红
      // isRedInvoice false是蓝票
      if (this.isRedInvoice) {
        // 红票
        this.$getJSON(`${apis.invoiceGoRedDetail}/${this.invoiceId}`).then((res) => {
          this.invoiceInfo = res.data || {};
        });

      } else {
        // 蓝票
        this.$getJSON(`${apis.invoiceDetail}/${this.invoiceId}`).then((res) => {
          this.invoiceInfo = res.data || {};
        });
      }

    },

  }
};
</script>

<style lang="scss">
.invoice-register {
  .record-detail {
    padding: 20px 0;
  }
}
</style>
